import { distinctFilter } from "../utils/dataManipulation";
import { sentenceCase } from "../utils/namesManipulation";

export const extractLocations = (allBuildings, nullAlternative) => {
  if (!allBuildings) return allBuildings;
  const dataLocations = allBuildings
    ?.map((building) => {
      if (!building?.location) return nullAlternative;
      return sentenceCase(building?.location);
    })
    ?.filter(distinctFilter);
  return dataLocations;
};

export const extractCertifications = (allBuildings, nullAlternative) => {
  if (!allBuildings) return allBuildings;
  const dataCertificates = allBuildings
    ?.reduce((total, current) => {
      const certificates = current?.certificate?.filter((cert) => cert.type !== "EU EPC")?.map((cert) => cert.type);
      if (!certificates || certificates.length === 0) total.push(nullAlternative);
      else {
        total.push(...(certificates || []));
      }
      return total;
    }, [])
    .filter(distinctFilter);
  return dataCertificates;
};

export const energyEfficiencyClassConf = [
  {
    bgColor: "var(--core-color-cathode-green-900)",
    max: 30,
    rating: "+A",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-cathode-green-700)",
    max: 50,
    rating: "A",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-cathode-green-600)",
    max: 75,
    rating: "B",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-cathode-green-300)",
    max: 100,
    rating: "C",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-star-600)",
    max: 130,
    rating: "D",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-tangerine-500)",
    max: 160,
    rating: "E",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-mystic-red-600)",
    max: 200,
    rating: "F",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-mystic-red-800)",
    max: 250,
    rating: "G",
    textColor: "#fff",
  },
  {
    bgColor: "var(--core-color-mystic-red-900)",
    max: Infinity,
    rating: "H",
    textColor: "#fff",
  },
];

export const getEnergyClassItem = ({ conf = energyEfficiencyClassConf, energyClass, energyConsumption }) => {
  const indexInConf = conf?.findIndex(
    (element) =>
      energyClass === element.rating ||
      (energyConsumption < element.max && energyConsumption !== null && energyConsumption !== undefined)
  );
  if (indexInConf === -1) return;
  return conf[indexInConf];
};
